import { styled } from 'goober'
import { useTheme } from '../useTheme'
import { useBreakpoints } from '../useBreakpoints'

export const useConfigComponentsStyles = () => {
  const theme = useTheme()
  const { smUp } = useBreakpoints()

  const shadowColor =
    theme?.palette?.mode === 'dark'
      ? 'rgb(125 104 163 / 13%)'
      : 'rgba(58, 53, 65, 0.10)'

  return {
    // PanelHeader styles
    PanelHeaderContainer: styled('div')(({ openConfigUnsaved }) => ({
      height: '60px',
      minHeight: '60px',
      maxHeight: '60px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 1rem',
      gap: '1rem',
      justifyItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: theme?.palette?.background?.paper || '#ffffff',
      borderTopRightRadius: '10px',
      borderTopLeftRadius: '10px',
      boxShadow: openConfigUnsaved ? 'none' : `0px 2px 10px 0px ${shadowColor}`,
      borderBottom: `1px solid ${theme?.palette?.divider || '#e0e0e0'}`,
      flexShrink: 0
    })),

    PanelHeaderContent: styled('div')({
      display: 'flex',
      alignItems: 'center'
    }),

    PanelHeaderTitle: styled('p')({
      fontSize: '16px',
      fontWeight: 500,
      color: theme?.palette?.text?.primary || '#000000',
      margin: 0,
      marginLeft: !smUp ? '5px' : 0
    }),

    // Unsaved changes dialog styles
    UnsavedChangesContainer: styled('div')({
      height: '30pt',
      padding: '0 1.5rem 0.5rem 1.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      backgroundColor: theme?.palette?.background?.paper || '#ffffff',
      color: theme?.palette?.text?.primary || '#000000'
    }),

    UnsavedChangesText: styled('p')({
      fontSize: '13px',
      textAlign: 'left',
      flexGrow: 0,
      marginRight: smUp ? 0 : '1px',
      width: '70%'
    }),

    UnsavedChangesButtonContainer: styled('div')({
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: smUp ? '1.5rem' : '1rem',
      margin: `0 ${smUp ? '10px' : '1.2rem'} 0 10px`,
      width: '30%'
    }),

    UnsavedChangesNoButton: styled('button')({
      all: 'unset',
      textTransform: 'uppercase',
      cursor: 'pointer',
      fontSize: '13px',
      marginLeft: '-10px'
    }),

    UnsavedChangesYesButton: styled('button')({
      all: 'unset',
      textTransform: 'uppercase',
      fontSize: '13px',
      cursor: 'pointer',
      marginLeft: '6px',
      color: theme?.palette?.primary?.main || '#1976d2'
    }),

    // Collapsible styles
    CollapsibleStyle: (openConfigUnsaved) => ({
      boxShadow: openConfigUnsaved ? `0px 4px 4px -2px ${shadowColor}` : 'none',
      maxWidth: '100%'
    }),

    // PanelBody styles
    PanelBodyContainer: styled('div')(({ sectionsArr }) => ({
      color: theme?.palette?.text?.primary || '#000000',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      justifyContent: sectionsArr?.length > 0 ? 'flex-start' : 'center',
      padding: '0 1rem'
    })),

    PanelBodyContent: styled('div')({
      width: '100%'
    }),

    PreferenceSection: styled('div')({
      marginTop: '1rem'
    }),

    PreferenceSectionTitle: styled('p')({
      fontSize: '14px',
      fontWeight: 600,
      color: theme?.palette?.text?.primary || '#000000',
      marginBottom: '0.8rem'
    }),

    PreferenceSectionContent: styled('div')({
      padding: '1rem',
      backgroundColor: theme?.palette?.action?.hover || 'rgba(0, 0, 0, 0.04)',
      borderRadius: '5px'
    }),

    PreferenceTopicContainer: styled('div')(({ isLast }) => ({
      ...(isLast ? {} : { paddingBottom: '1.5rem' })
    })),

    PreferenceTopicHeader: styled('div')({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: '0.7rem'
    }),

    PreferenceTopicName: styled('p')({
      fontSize: '14px',
      color: theme?.palette?.text?.primary || '#000000'
    }),

    PreferenceChannelContainer: styled('div')({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '0.5rem'
    }),

    PreferenceFillerDiv: styled('div')({
      height: '1rem'
    }),

    // Empty state styles
    EmptyStateContainer: styled('div')({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center'
    }),

    EmptyStateText: styled('p')({
      padding: '0 1rem',
      margin: 0,
      color: theme?.palette?.secondary?.main || '#9c27b0'
    }),

    // PreferenceSaveButton styles
    SaveButtonWrapper: styled('div')({
      margin: '0.5rem',
      position: 'relative'
    })
  }
}
